import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';
import styles from './Benefits.module.scss';

const Benefits = () => {
    return ( 
        <div  className={styles.container}>
            <Stack
                direction = 'column'
                gap = '16'
                justifyContent='justifyStart'
                alignItems ='alignCenter'
                className={styles.content}
            > 
                <Text
                    type='h3'  
                    size='m' 
                    className={styles.title}>
                        ПОЧЕМУ ПАЦИЕНТЫ ВЫБИРАЮТ НАС
                </Text> 
                    <Text                            
                        className={styles.text}>
                            Наша клиника работает для Вас с 2015 года.
                            Мы всегда думаем о вашем комфорте.
                            Поход к стоматологу может стать для некоторых людей стрессовым испытанием. 
                            Мы предоставляем камерную обстановку, окружаем наших пациентов заботой и вниманием.
                    </Text>
                    <Text                            
                        className={styles.text}>
                            Качественное обслуживание сочетается с высоким профессионализмом 
                            наших врачей, которые регулярно посещают курсы и семенары по повышению квалификации и 
                            используют современные протоколы лечения.                          
                    </Text>
                    <Text                            
                        className={styles.text}>
                            Мы используем современное оборудование, качественные материалы и анестезию, 
                            особое внимание уделяется обработке инструментов.                         
                    </Text>
                    <Text                            
                        className={styles.text}>
                            Наш администратор напомнит о приеме, а ассистент врача-стоматолога 
                            сделает его более быстрым и комфортным.                          
                    </Text>
                    <Text                            
                        className={styles.text}>
                            Мы даем полную гарантию на все виды услуг. 
                            Фиксируем цены в плане лечения и не поднимаем в процессе.
                            Также предоставляем любые способы оплаты: наличными, банковской картой, QR.
                            После лечения вы получите все необходимые документы и сможете оформить наловый вычет.                           
                    </Text>
            </Stack>
    </div>
    );
}
export default Benefits;